export const makeEqByPropList = (propList: string[]) => (a: any, b: any) => propList.every((key) => a[key] === b[key]);
